export default __webpack_public_path__ + "b3826dd5009651052dcb319d71c19be4.png";